import * as React from "react";
import { useQueryClient } from "@tanstack/react-query";
import ViewLoaderContext from "views/logic/ViewLoaderContext";
import { Link } from "components/common";
import Routes from "routing/Routes";
import FavoriteIcon from "views/components/FavoriteIcon";
import { createGRN } from "logic/permissions/GRN";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import { useTableFetchContext } from "components/common/PaginatedEntityTable";
const onLoad = (onLoadSavedSearch, selectedSavedSearchId, loadFunc) => {
  if (!selectedSavedSearchId || !loadFunc) {
    return false;
  }
  loadFunc(selectedSavedSearchId);
  onLoadSavedSearch();
  return false;
};
const SavedSearchFavIcon = ({ isFavorite, search }) => {
  const queryClient = useQueryClient();
  const { searchParams } = useTableFetchContext();
  return /* @__PURE__ */ React.createElement(
    FavoriteIcon,
    {
      isFavorite,
      grn: createGRN("search", search.id),
      onChange: (newValue) => {
        queryClient.setQueriesData(
          { queryKey: ["saved-searches", "overview", searchParams] },
          (cur) => ({
            ...cur,
            list: cur.list.map((view) => {
              if (view.id === search.id) {
                return view.toBuilder().favorite(newValue).build();
              }
              return view;
            })
          })
        );
      }
    }
  );
};
const useColumnRenderers = (onLoadSavedSearch) => {
  const { pluggableColumnRenderers } = usePluggableEntityTableElements(null, "search");
  return {
    attributes: {
      title: {
        renderCell: (title, search) => /* @__PURE__ */ React.createElement(ViewLoaderContext.Consumer, { key: search.id }, (loaderFunc) => {
          const onClick = (e) => {
            e.preventDefault();
            onLoad(onLoadSavedSearch, search.id, loaderFunc);
          };
          return /* @__PURE__ */ React.createElement(Link, { onClick, to: Routes.SEARCH_SHOW(search.id) }, title);
        })
      },
      favorite: {
        renderCell: (isFavorite, search) => /* @__PURE__ */ React.createElement(SavedSearchFavIcon, { isFavorite, search })
      },
      ...pluggableColumnRenderers || {}
    }
  };
};
export default useColumnRenderers;
